module.exports = __webpack_public_path__ + "static/img/Frame15.cacd3cb3.png";